import * as React from 'react';
import type { SVGProps } from 'react';

const SvgDiscountIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="108"
    height="108"
    fill="none"
    viewBox="0 0 108 108"
    {...props}
  >
    <g id="Group 427319497">
      <path
        id="Vector"
        d="M72.3089 92.3649L72.7668 94.745C72.7948 94.8905 72.8149 95.0378 72.826 95.1822C73.0209 97.3792 71.4951 99.412 69.2448 99.8315L29.7273 107.198C27.5369 107.607 25.4191 106.347 24.7204 104.329C24.9255 104.32 25.1366 104.297 25.3441 104.258L64.8618 96.8915C67.1122 96.4719 68.6387 94.443 68.4428 92.2422C69.671 92.8812 71.0983 92.8963 72.3086 92.365L72.3089 92.3649Z"
        fill="#5F59FF"
      />
      <path
        id="Vector_2"
        d="M11.2939 44.3513L29.2874 18.364L55.6887 36.0752C57.1408 37.0494 58.1402 38.5512 58.4671 40.2506L68.3868 91.8065C68.8413 94.1683 67.2645 96.4456 64.8651 96.8929L25.3464 104.26C22.9469 104.707 20.6334 103.155 20.179 100.793L10.2593 49.2374C9.93231 47.538 10.3045 45.7805 11.2942 44.3512L11.2939 44.3513Z"
        fill="white"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M101.194 61.0702L78.5431 93.7834C77.2593 95.6327 74.7899 96.2029 72.8256 95.1833C72.8143 95.0386 72.7944 94.8917 72.7664 94.7462L72.3084 92.3661C73.0297 92.0482 73.6803 91.5356 74.1598 90.8431L96.8103 58.1299C98.1872 56.1413 97.6663 53.4343 95.646 52.079L100.029 55.0196C102.049 56.3749 102.57 59.0817 101.193 61.0706L101.194 61.0702Z"
        fill="#5F59FF"
      />
      <g id="Vector_4">
        <path
          d="M36.7275 23.3535L46.6318 21.5072C48.3586 21.1853 50.1473 21.5527 51.5975 22.5256L95.6472 52.0761C97.6675 53.4314 98.1883 56.1382 96.8115 58.1271L74.161 90.8403C72.8771 92.6893 70.4077 93.2598 68.4434 92.2402"
          fill="white"
        />
        <path
          d="M36.7275 23.3535L46.6318 21.5072C48.3586 21.1853 50.1473 21.5527 51.5975 22.5256L95.6472 52.0761C97.6675 53.4314 98.1883 56.1382 96.8115 58.1271L74.161 90.8403C72.8771 92.6893 70.4077 93.2598 68.4434 92.2402"
          stroke="#383838"
          strokeWidth="0.570513"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        id="Vector_5"
        d="M5.65131 43.1967L22.2923 19.1628L46.7092 35.5428C48.0519 36.4435 48.9764 37.8324 49.2788 39.4044L58.4529 87.0849C58.8732 89.2694 57.4149 91.3755 55.1957 91.7892L18.6474 98.6024C16.4282 99.0161 14.2885 97.5808 13.8682 95.3963L4.69419 47.7157C4.39181 46.1441 4.73597 44.5187 5.65131 43.1967Z"
        fill="#E0DFFF"
      />
      <path
        id="Vector_6"
        d="M81.0402 68.1168L87.988 58.0819C88.6206 57.1683 88.3809 55.9227 87.4528 55.3001L74.8486 46.8444"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_7"
        d="M34.3889 44.8802C37.3279 44.3323 39.2592 41.5431 38.7026 38.6502C38.1459 35.7573 35.3122 33.8563 32.3732 34.4042C29.4343 34.9521 27.503 37.7413 28.0596 40.6342C28.6162 43.5271 31.4499 45.4281 34.3889 44.8802Z"
        fill="#5F59FF"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_8"
        d="M38.7383 38.8817C38.2391 39.0195 37.7312 39.1345 37.2156 39.2306C34.0499 39.8207 30.9195 39.5811 28.0599 38.6635C24.6324 37.5705 21.5902 35.509 19.3283 32.7476C17.4775 30.4885 16.1496 27.761 15.5622 24.708C13.6577 14.8095 20.2638 5.26851 30.3201 3.39384C40.3763 1.51917 50.0694 8.0217 51.9739 17.9202C52.9292 22.8853 51.7434 27.7604 49.0494 31.6205"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_9"
        d="M11.2939 44.3513L29.2874 18.364L55.6887 36.0752C57.1408 37.0494 58.1402 38.5512 58.4671 40.2506L68.3868 91.8065C68.8413 94.1683 67.2645 96.4456 64.8651 96.8929L25.3464 104.26C22.9469 104.707 20.6334 103.155 20.179 100.793L10.2593 49.2374C9.93231 47.538 10.3045 45.7805 11.2942 44.3512L11.2939 44.3513Z"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_10"
        d="M33.9173 67.4412C35.2195 64.5315 33.8788 61.1336 30.9227 59.8518C27.9666 58.5701 24.5146 59.8897 23.2124 62.7995C21.9101 65.7092 23.2509 69.1071 26.2069 70.3889C29.163 71.6707 32.6151 70.351 33.9173 67.4412Z"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_11"
        d="M53.0608 75.7415C54.363 72.8318 53.0223 69.4339 50.0662 68.1521C47.1102 66.8703 43.6581 68.19 42.3559 71.0997C41.0537 74.0095 42.3944 77.4074 45.3505 78.6891C48.3066 79.9709 51.7586 78.6513 53.0608 75.7415Z"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_12"
        d="M32.7235 81.3603L43.5466 57.1768"
        stroke="#383838"
        strokeWidth="0.570513"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgDiscountIllustration;
